import { Dispatch } from 'redux';
import { getPortalAlert } from '../../graphql/queries';
import {
  GET_ADMINPORTALALERT_REQUESTED,
  GET_ADMINPORTALALERT_COMPLETED,
  GET_ADMINPORTALALERT_FAILED,
} from './types';
import api from '../../services/api';
import debug from '../../services/debug';

const getPortalAlertAction = () => async (dispatch: Dispatch) => {
  dispatch({
    type: GET_ADMINPORTALALERT_REQUESTED,
  });

  try {
    const { data } = await api.graphql({
      query: getPortalAlert,
    });
    debug(GET_ADMINPORTALALERT_COMPLETED, data);

    dispatch({
      type: GET_ADMINPORTALALERT_COMPLETED,
      payload: data.getPortalAlert,
    });
  } catch (err) {
    debug(GET_ADMINPORTALALERT_FAILED, err);

    dispatch({
      type: GET_ADMINPORTALALERT_FAILED,
      payload: err,
    });
  }
};

export default getPortalAlertAction;
